import { render } from "./GRNItemInwardDetails.vue?vue&type=template&id=6d0651d4&scoped=true"
import script from "./GRNItemInwardDetails.vue?vue&type=script&lang=js"
export * from "./GRNItemInwardDetails.vue?vue&type=script&lang=js"

import "./GRNItemInwardDetails.vue?vue&type=style&index=0&id=6d0651d4&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d0651d4"]])

export default __exports__